import { all, put, takeEvery } from 'redux-saga/effects'
import _ from 'lodash'

import config from '../../../../../../../../../config'

import { BLOCK_DATA_LOADED } from '../../../../../../../components/Workspace/components/HocBlock/constants'
import { blockDataTransformed } from '../../../../../../../components/Workspace/components/HocBlock/actions'

function* onDataLoaded(_action) {
    const blockKey = _.get(_action, 'data.blockKey', null)
    if (blockKey !== config.modules.report.blocks.contacts.key) return null

    const module = _.get(_action, 'data.module', null)
    const id = _.get(_action, 'data.id', null)
    if (!module || !id || !blockKey) return null

    const respData = _.get(_action, 'data.data.data', null)

    let order = 0
    const transformedData = _.reduce(
        respData,
        (acc, data, index) => {
            order += 1
            acc.push({ type: index, order, data })

            return acc
        },
        []
    )

    yield put(blockDataTransformed(module, id, blockKey, transformedData))

    return null
}

export default function* blockTransformSaga() {
    yield all([takeEvery(BLOCK_DATA_LOADED, onDataLoaded)])
}
